<script setup>
import { ref, onMounted } from 'vue'
import { Icon } from '@components'
import moment from "moment"
import DetailsModal from './DetailsModal.vue'
import useDetailsModal from './useDetailsModal.js'
const { isDetailsModalActive, activeAppointmentId, openDetailsModal, closeDetailsModal, calculateDetailsModalPosition, calculateArrowPosition } = useDetailsModal()

const emit = defineEmits(['close'])

const props = defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    row_index: {
        type: Number,
        default: null
    },
    col_index: {
        type: Number,
        default: null
    },
    period: {
        type: String,
        default: null
    }
})

const closeModal = () => {
    emit('close')
}

onMounted(() => {
    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('prebook-appointment-more-button') || event.target.closest('.prebook-appointment-details-modal')) return

        //   remove modal if click outside
        if (!event.target.closest('.prebook-appointment-more-list-modal')) closeModal()
    })
})
</script>


<template>
    <div class="prebook-appointment-more-list-modal w-[250px] max-h-[800px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute z-50 bg-white rounded-lg shadow-lg">
        <div class="flex items-center justify-between gap-2 mb-3 p-4">
            <div class="text-base font-semibold text-[#101828]">{{ items.appointments.length || 0 }} <span class="text-[#667085]">Appointments</span></div>
            <Icon name="xClose" @click="closeModal()" class="cursor-pointer text-[#98A2B3]"></Icon>
        </div>

        <template v-for="list in items.appointments">
            <DetailsModal v-if="isDetailsModalActive && activeAppointmentId == list.appointment_id" :appointmentId="activeAppointmentId" @close="closeDetailsModal" :style="calculateDetailsModalPosition(props.row_index, props.col_index, props.period, true)" />
        </template>

        <div class="max-h-[260px] overflow-y-auto p-4">
            <div v-for="list in items.appointments" class="relative mb-1 last:mb-0">
                <!-- <DetailsModal v-if="isDetailsModalActive && activeAppointmentId == list.appointment_id" :appointmentId="activeAppointmentId" @close="closeDetailsModal" :style="calculateDetailsModalPosition(props.row_index, props.col_index, props.period)" /> -->
                <div @click="openDetailsModal(list.appointment_id)" class="cursor-pointer relative z-10 flex gap-1 items-center text-[12px] p-[20px_12px] rounded-[1px] w-full h-[55px]" :style="`background: ${list.color_palette?.background}; color: ${list.color_palette?.text};`">
                    <svg v-if="isDetailsModalActive && activeAppointmentId == list.appointment_id" class="absolute transition-all duration-500" :style="calculateArrowPosition(props.col_index, props.period)?.style" xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none">
                        <defs>
                            <filter id="shadow-normal" x="0" y="0">
                                <feDropShadow dx="-1" dy="0" stdDeviation="1" flood-color="#99999999" flood-opacity="1" />
                            </filter>
                            <filter id="shadow-rotated" x="0" y="0">
                                <feDropShadow dx="-1" dy="-1" stdDeviation="1" flood-color="#99999999" flood-opacity="1" />
                            </filter>
                        </defs>
                        <path d="M1.38553 12.7039C0.0997374 11.5162 0.0997363 9.48438 1.38553 8.29661L10.25 0.107971L10.25 20.8926L1.38553 12.7039Z" fill="white" :filter="calculateArrowPosition(props.col_index)?.isRotated ? 'url(#shadow-rotated)' : 'url(#shadow-normal)'" />
                    </svg>
                    <div class="absolute top-0 left-0 w-0 h-0 border-t-[8px] border-r-[8px] border-r-transparent" :style="`border-top-color:${list.color_palette?.arrow}`"></div>
                    <div class="bg-white absolute top-[2px] skew-y-[-46deg] w-2.5 h-1 left-0"></div>
                    <div class="truncate font-medium w-[calc(100%-38px)]">{{ list.meta?.service_name }}</div>
                    <div class="ml-auto text-nowrap">{{ moment(list.booking_time_start, 'HH:mm').format('h:mm A') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>


<style>

</style>